import React, {useCallback, useMemo, useRef} from 'react';
import {Popup} from "devextreme-react/popup";
import DataGrid, {Column, DataGridRef, Editing, Toolbar} from "devextreme-react/data-grid";
import {NumberBox} from "devextreme-react";
import IOptionReservation, {OptionReservationTypeChamp} from "../../models/OptionReservation";
import {TypeAuxiliaire} from "../../models/TypeAuxiliaire";
import {Button} from "devextreme-react/button";
import "./popup-options.css";

interface IPopupOptionProps {
    optionsReservation: IOptionReservation [],
    onClose: (e: any) => void,

}

const style: React.CSSProperties | undefined = {display: "flex", height: "100%", flexDirection: "column", alignItems: "end", gap: "1rem"};
const selectCellComponent = (cellElement: any) => {
    const {data} = cellElement;

    const option = data;
    if (option.typeChamp == OptionReservationTypeChamp.Numerique) {
        return <NumberBox style={{backgroundColor: "rgba(0,0,0,.04)"}} format={"#0.00"} value={option.quantite}/>
    }

    return null
};

const onEditorPreparing = (e: any) => {
    if (e.dataField === "quantite") {
        if (e.row?.data.typeChamp === OptionReservationTypeChamp.Logical) {
            e.cancel = true;
        } else {
            e
        }
    }
};

const quantiteCellValue = (newData: any, value: any, currentRow: any) => {
    newData.quantite = value;
    newData.selected = value > 0;
};

const selectedCellValue = (newData: any, value: any, currentRow: IOptionReservation) => {

    if (currentRow.typeChamp == OptionReservationTypeChamp.Numerique) {
        if (!value)
            newData.quantite = 0;
        else
            newData.quantite = 1;
    }

    newData.selected = value
};
const onEditorPrepared = (e: any) => {
    if (e.parentType == "dataRow" && e.dataField == "quantite") {
        e.editorElement.style.backgroundColor = "rgba(0,0,0,.04)"
    }

};
const quantiteEditorOptions = {format: "#0.00"};

const PopupOptions = ({optionsReservation, onClose}: IPopupOptionProps) => {
    const dataSource = useMemo(() => optionsReservation
            .filter(f => f.typeAuxiliaire !== TypeAuxiliaire.Message)
            .map(m => ({...m, quantite: m.ajoutAutomatique ? !m.quantite || m.quantite == 0 ? 1 : m.quantite : 0, selected: m.ajoutAutomatique || m.selected || false}))
        , [optionsReservation]);

    const onClick = useCallback(() => {
        dataGridRef?.current?.instance().saveEditData();
        onClose(dataSource.filter(f => f.selected))
    }, [onClose, dataSource]);

    const dataGridRef = useRef<DataGridRef>(null);

    return (
        <Popup
            onHiding={onClose}
            visible={true}
            dragEnabled={true}
            resizeEnabled={true}
            hideOnOutsideClick={false}
            showCloseButton={true}
            showTitle={true}
            dragOutsideBoundary={true}
            title="Options de réservation"
            width={"600px"}
            height={"auto"}
        >
            <div style={style}>
                <DataGrid ref={dataGridRef} height={"100%"} dataSource={dataSource} onEditorPrepared={onEditorPrepared} onEditorPreparing={onEditorPreparing}>
                    <Toolbar visible={false}/>
                    <Editing allowAdding={false} allowDeleting={false} allowUpdating={true} mode={"batch"} startEditAction={"click"} selectTextOnEditStart={true}/>
                    <Column dataField={"description"} caption={"Description"} allowEditing={false}/>
                    <Column dataField={"quantite"} caption={""} width={"80px"} alignment={"center"} dataType={"number"} editorOptions={quantiteEditorOptions} showEditorAlways={true} setCellValue={quantiteCellValue}/>
                    <Column dataField={"selected"} caption={""} dataType={"boolean"} width={"35px"} alignment={"center"} setCellValue={selectedCellValue}/>
                </DataGrid>
                <Button onClick={onClick} width={"6rem"} text={"Ok"}/>
            </div>
        </Popup>
    );
};

export default PopupOptions;